Vue.component('profiledataselect', {
    props: {
        fieldid: {
            type: String
        },
        isParentUpdating: {
            type: Boolean
        },
        filtertype: {
            type: String
        },
        forceMax: {

        },
        minmax: {
            type: Object,
            default: {}
        },
        selectedData: {
            type: Object
        },
        matchedDistricts: {
            type: Object
        },
        fielddata: {},
        selected: {
            type: Boolean,
            default: false,
            required: false
        },
        
    },
    data () {
        return {
            rangeMultiplier: .25,
            checked: false,
            modalActive: false,
            cancelModal: false,
            selectedStart: false,
            selectedEnd: false,
            selectedCategories: false,
            selectedBoolean: false,
        }
    },
    computed: {
        selectedvalue () {
            return this.selectedData[this.fieldid];
        },
        selectedDistrictsText () {
            switch (this.filtertype) {
                case "range":
                    return "Matching on " + formatSlideData(this.selectedRangeStart, this.field.data_format, this.field) + ' through ' + formatSlideData(this.selectedRangeEnd,this.field.data_format, this.field);
                case "category": 
                    if (this.selectedCategories) {
                        let text = '';                        
                        for (const cat of Object.keys(this.selectedCategories)) {
                            if (text += '') {text += " or ";}
                            text += formatSlideData(cat, this.field.data_format, this.field);
                        }
                        return 'Matching on ' + text;
                    }
                    return;
                case "boolean":
                    if (this.selectedBoolean) {
                        return 'Matching on ' + this.selectedBoolean;
                    }
                    return 'Matching on ' + this.selectedvalue;
                    
            }
        },
        min () {
            if (Object.keys(this.minmax).length === 0) {
                return false;
            }
            if (this.minmax[this.fieldid*1]) {
                return (this.minmax[this.fieldid*1].min)*1
            }   
            return false;
        },
        max () {
            if (this.forceMax && this.forceMax != "false") {
                return this.forceMax * 1;
            }
            if (Object.keys(this.minmax).length === 0) {
                return false;
            }
            if (this.minmax[this.fieldid*1]) {
                return (this.minmax[this.fieldid*1].max)*1
            }   
            return false;
        },
        profileData () {
            if (this.fieldid == agencyStateFauxKey.toString()) {return this.selectedData[agencyStateFauxKey * 1];}
            if (typeof this.field === "undefined") {return false;}
            if (this.field.data_format == "Text") {
                return this.selectedData[this.fieldid*1];
            }
            if (this.selectedData[this.fieldid*1]) {
                return this.selectedData[this.fieldid*1]*1;
            }
            //return this.selectedData[this.fieldid*1];
            //console.log(this.fieldid);
            return false;
        },
        profileDataFormatted () {
            return formatSlideData(this.profileData, this.field.data_format, this.field)
        },
        selectedRangeStart () {
            if (!this.profileData) {return false;}
            if (this.selectedStart) {return this.selectedStart;}
            return this.profileData - (this.profileData * this.rangeMultiplier);
        },
        selectedRangeEnd () {
            if (!this.profileData) {return false;}
            if (this.selectedEnd) {return this.selectedEnd;}
            return this.profileData + (this.profileData * this.rangeMultiplier);
        },
        field () {
            if (this.fieldid == agencyStateFauxKey) {
                let f = {
                    data_field_id: agencyStateFauxKey,
                    data_definition: "State",
                    data_format: "Text"
                }
                return f;
            }
            if (this.fielddata) {
                return this.fielddata[this.fieldid]
            }
        },
        headerText () {
            if (this.field.data_name) {return this.field.data_name;}
            return 'Restrict to your state'
        },
        numMatches () {
            if (this.matchedDistricts && this.matchedDistricts[this.fieldid]) {
                return formatSlideData(this.matchedDistricts[this.fieldid].length, "Number");
            }
            return 0;
        }
    },
    mounted () {
        this.checked = this.selected
        if (!this.checked) {
            let e = {target: {checked: false}}
            //this.updateCheckbox(e);
        }
    },
    methods: {
        updaterange (start, end) {
            this.$emit("updaterange", this.field, start, end)
            this.selectedStart = start;
            this.selectedEnd = end;
        },
        updateboolean (val) {
            this.selectedBoolean = val;
            if (this.checked) {
                this.$emit("updateboolean", this.field, val);
            }
            
            
        },
        updatecategory (field, vals) {
            this.$emit("updatecategory", this.field, vals);
            this.selectedCategories = vals;
        },
        updateCheckbox (e) {
            this.checked = e.target.checked;
            let start, end;
            if (!this.checked) {
                start = -999;
                end = -999;
                switch (this.filtertype) {
                    case "range":
                        this.$emit("updaterange", this.field, start, end); 
                        break;
                    case "boolean":
                        this.$emit("updateboolean", this.field, start, end);
                        break;
                    case "category":
                        this.$emit("updatecategory", this.field, -999);
                        break;
                    case "none":
                        this.$emit("updatenone", this.field, false); 
                        break;
                }
                
            } else {
                switch (this.filtertype) {
                    case "range":
                        start = this.selectedRangeStart;
                        end = this.selectedRangeEnd;
                        this.$emit("updaterange", this.field, start, end); 
                        break;
                    case "boolean":
                        val = "Y";
                        this.$emit("updateboolean", this.field, val);
                        break;
                    case "category":
                        this.$emit("updatecategory", this.field, this.selectedCategories); 
                        break;
                    case "none":
                        this.$emit("updatenone", this.field, true);
                }
                
            }
        },
        applyModal () {
            // TODO: EMIT CHECKBOX TO SELECT ITEM IF NOT SELECTED ON OPEN
            // OVERRIDE IF MODAL ALREADY OPEN
            if (this.cancelModal) {
                this.cancelModal = false;
                return;
            }
            let e = {target: {checked: true}};
            this.updateCheckbox(e);
            
            this.modalActive = true;
            let id = "pds-" + this.fieldid;
            let div = document.getElementById(id);
            let startPos = div.getBoundingClientRect();
            let widthAsPercent = (startPos.width / screen.width) * 100;
            let heightAsPercent = (startPos.height / screen.height) * 100;
            

            div.style.left = startPos.x + "px";
            div.style.top = startPos.y + "px";
            div.style.position = "fixed";
            
            let start, translateX, translateY, currWidth;
            let stopX = -1 * startPos.x;
            let stopY = -1 * startPos.y;
            let stopWidth = 100;
            let stopHeight = 100;
        
            function step(timestamp) {
                div.classList.add('full');
                if (start === undefined)
                  {start = timestamp;}
                const elapsed = timestamp - start;
                // `Math.min()` is used here to make sure that the element stops at exactly 200px.

                translateX = Math.min(0.2 * elapsed, stopX);
                translateY = Math.min(0.2 * elapsed, stopY);
                widthAsPercent = Math.min(2 * widthAsPercent, stopWidth);
                heightAsPercent = Math.min(2 * heightAsPercent, stopHeight);
                
                div.style.transform = 'translate(' + translateX + 'px, ' + translateY + 'px)';
                div.style.width = widthAsPercent + '%';
                div.style.height = heightAsPercent + '%';
                
                if (translateX > stopX || translateY > stopY || widthAsPercent < stopWidth || heightAsPercent < stopHeight) { // Stop the animation when we're full screen
                  window.requestAnimationFrame(step);
                  
                } else {
                    div.classList.add('flex')
                }
              }
              
              window.requestAnimationFrame(step);
            
        },
        closeModal () {
            // TODO: EMIT REFRESH TO TRIGGER REFRESH
            this.cancelModal = true;
            this.modalActive = false;
            
            let refresh = document.getElementById('refresh_peers_button');
            refresh.click();

            let id = "pds-" + this.fieldid;
            let div = document.getElementById(id);
            div.classList.remove('flex');
            div.classList.remove('full');
            div.style.position = "relative";
            div.style.transform = "revert";
            div.style.width = 'revert';
            div.style.height = 'revert';
            div.style.left = 'revert';
            div.style.top = 'revert';
        }
    }
});
